
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_32109","data-name":"Group 32109","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_9339","data-name":"Rectangle 9339","width":"18","height":"18","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_32112","data-name":"Group 32112","clip-path":"url(#clip-path)"}},[_c('g',{attrs:{"id":"Group_25773","data-name":"Group 25773","transform":"translate(3.122 2.343)"}},[_c('g',{attrs:{"id":"Group_25778","data-name":"Group 25778","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_6491","data-name":"Path 6491","d":"M1.706 2.992l1.176 8.934a2.128 2.128 0 00.481 1.239 1.619 1.619 0 001.176.507h3.843a1.619 1.619 0 001.176-.507 2.312 2.312 0 00.481-1.247l1.176-8.934","transform":"translate(-.582 -.358)"}}),_c('path',{attrs:{"id":"Path_6492","data-name":"Path 6492","d":"M8.154 3.021V1.708a1.126 1.126 0 00-.212-.681.646.646 0 00-.517-.277H4.7a.646.646 0 00-.517.277 1.126 1.126 0 00-.212.681v1.313","transform":"translate(-.185 -.75)"}}),_c('path',{attrs:{"id":"Path_21120","data-name":"Path 21120","d":"M7.735 2.75V-.777","transform":"translate(-.429 6.858)"}}),_c('path',{attrs:{"id":"Path_21121","data-name":"Path 21121","d":"M7.735 2.75V-.777","transform":"translate(-3.1 6.858)"}}),_c('line',{attrs:{"id":"Line_689","data-name":"Line 689","x2":"11.755","transform":"translate(0 2.587)"}})])])])])
          )
        }
      }
    